import api from './api';

export interface LicenseInfo {
  valid: boolean;
  license_key?: string;
  plan?: string;
  status?: string;
  is_lifetime?: boolean;
  max_clients?: number;
  max_contracts?: number;
  max_users?: number;
  modules?: string[];
  valid_until?: string | null;
  days_remaining?: number | null;
  error?: string;
  cached?: boolean;
}

export interface LicenseInvoice {
  id: string;
  invoice_number: string;
  description: string;
  amount: number;
  discount: number;
  total: number;
  due_date: string;
  paid_at?: string;
  status: 'pending' | 'paid' | 'overdue' | 'cancelled';
  payment_method?: string;
  gateway: 'asaas' | 'efi' | 'manual';
  gateway_boleto_url?: string;
  gateway_pix_qrcode?: string;
  gateway_pix_copia_cola?: string;
  reference_month: number;
  reference_year: number;
}

export interface LicenseInvoicesResponse {
  license: {
    key: string;
    plan: string;
    status: string;
    is_lifetime: boolean;
    valid_until?: string | null;
    modules: string[];
    company: {
      razao_social: string;
      nome_fantasia?: string;
      cnpj_cpf: string;
    };
  } | null;
  invoices: LicenseInvoice[];
}

export const licenseService = {
  getStatus: async (force = false): Promise<LicenseInfo> => {
    const res: any = await api.get('/license/status', {
      params: { force },
    });
    // Se o backend retornou { success: true, data: { ... } }, extrai .data, senão usa res diretamente
    return res && res.data && typeof res.data === 'object' && 'valid' in res.data ? res.data : res;
  },

  getInvoices: async (): Promise<LicenseInvoicesResponse> => {
    try {
      const res: any = await api.get('/license/invoices');
      const payload = res && res.data && typeof res.data === 'object' && ('invoices' in res.data || 'license' in res.data) ? res.data : res;
      return payload || { license: null, invoices: [] };
    } catch {
      return { license: null, invoices: [] };
    }
  },

  activate: async (license_key: string): Promise<any> => {
    const res: any = await api.post('/license/activate', { license_key });
    return res && res.data ? res.data : res;
  },
};
